import O1HD from "../../../../../../engines/gameEngine";
import data_control from "../../../../../../engines/libs/data_control";
import { GeneralKind } from "../../../../../define/GeneralKind";
import { MessageEventKind } from "../../../../../define/MessageEventKind";
import NormalGameManager from "../../../../manager/NormalGameManager";
import { getKaoguMountainConfig } from "./kaoguMountainConfig";

class kaoguData {
    private data: kaoguDataType = null;
    private readonly MaxGuaTime: number = 5
    getData() {
        return this.data
    }
    isfirst:boolean = false;
    init(data: kaoguDataType) {
        this.data = null;
        let curDay = data_control.getCurrDateDayString();
        if (!data || !data.mountainInfo) {
            this.isfirst = true;
            
            this.data = {
                kaoguChuizi: this.MaxGuaTime,
                mountainInfo: [],
                earthIDList: [],
                lastRefreshTime: curDay,
            }
            for (const key in getKaoguMountainConfig) {
                if (Object.prototype.hasOwnProperty.call(getKaoguMountainConfig, key)) {
                    const element = getKaoguMountainConfig[key];
                    this.data.mountainInfo.push({ id: element.id, ismine: false })
                }
            }
           this.saveData();
        } else {
            this.data = data;

            if (curDay != data.lastRefreshTime) {
                data.lastRefreshTime = curDay;
                this.changeNext(true);
            }
        }
    }

    saveData() {
        NormalGameManager._instance.setGameData({kaoguData: this.data});
        O1HD.emit(MessageEventKind.EventName.GAME_KAOGUDATA);
    }

    newDayRefresh() {
        this.data.kaoguChuizi = this.MaxGuaTime
        this.data.mountainInfo = []
        for (const key in getKaoguMountainConfig) {
            if (Object.prototype.hasOwnProperty.call(getKaoguMountainConfig, key)) {
                const element = getKaoguMountainConfig[key];
                this.data.mountainInfo.push({ id: element.id, ismine: false })
            }
        }
        this.saveData();
    }
    changeNext(bAdd: boolean = false){
        
        this.data.mountainInfo = []
        if (bAdd) {
            this.data.kaoguChuizi = 5;
        }
        for (const key in getKaoguMountainConfig) {
            if (Object.prototype.hasOwnProperty.call(getKaoguMountainConfig, key)) {
                const element = getKaoguMountainConfig[key];
                this.data.mountainInfo.push({ id: element.id, ismine: false })
            }
        }
        this.saveData();
    }
    getChuiziTimes() {
        if (this.data.kaoguChuizi == null) this.data.kaoguChuizi = this.MaxGuaTime
        return this.data.kaoguChuizi
    }
    addChuiziTimes(addNum: number) {
        if (this.data.kaoguChuizi == null) this.data.kaoguChuizi = this.MaxGuaTime
        this.data.kaoguChuizi += addNum;
        this.saveData();
    }
    setKaogu(id: number) {
        for (let data of this.data.mountainInfo) {
            if (data.id == id) {
                data.ismine = true;
                break;
            }
        }
        this.saveData();
    }

    setEarthIDList(id: number) {
        if (this.data.earthIDList == null) this.data.earthIDList = [];
        this.data.earthIDList.push(id)
        this.saveData();
    }
    getEarthIDList() {
        return this.data.earthIDList || []
    }
    delEarthItem() {
        if (this.data.earthIDList == null) this.data.earthIDList = [];
        else {
            this.data.earthIDList.splice(0, 1)
        }
        this.saveData();
    }

    getEarthPrefabName() {
        return this.data.earthPrefabName;
    }
    setEarthPrefabName(name: string = null) {
        this.data.earthPrefabName = name;
        this.saveData();
    }
}
export interface kaoguDataType {
    /**开采锤子次数 */
    kaoguChuizi: number,
    /**开采信息 */
    mountainInfo: { id: number, ismine: boolean }[],
    /**获取泥土物品ID */
    earthIDList: number[];

    /**泥土样式perfab名称 */
    earthPrefabName?: string;

    /** 最后刷新时间 */
    lastRefreshTime: string;
}
export const KaoguDataHelp = new kaoguData();

/** 神秘洞府 神农鼎、士卒甲、 工匠之锤、商贾秘术 */
export const MysticalHoleMansion = [GeneralKind.PropId.SHEN_NONG_DING, 50030, 50031, 50044];